import { gql } from '@apollo/client';

export interface SendPasswordResetLinkResponse {
  sendPasswordResetLink: {
    message: string;
  };
}

export const RESET_PASSWORD = gql`
  mutation sendPasswordResetLink($email: String!) {
    sendPasswordResetLink(email: $email) {
      message
    }
  }
`;
